import {
  IncentiveRule,
  IncentiveValueType,
  RefundOptimizationRule,
} from 'types/incentive';
import { normalizeIncentiveItemEligibility } from './IncentiveSettings.itemEligibility';

export const normalizeNonNegativeValue = (value: number) =>
  Number.isFinite(value) ? Math.max(0, value) : 0;

export const normalizePercentageValue = (value: number) =>
  Math.min(100, normalizeNonNegativeValue(value));

export const normalizeIncentiveValue = (
  value: number,
  valueType: IncentiveValueType,
) =>
  valueType === IncentiveValueType.PERCENTAGE
    ? normalizePercentageValue(value)
    : normalizeNonNegativeValue(value);

const normalizeOptionalNonNegativeValue = (value: number | null | undefined) =>
  value === null || value === undefined
    ? value
    : normalizeNonNegativeValue(value);

export const normalizeIncentiveRules = (rules: IncentiveRule[]) =>
  rules.map((rule) => ({
    ...rule,
    eligibility: normalizeIncentiveItemEligibility(rule.eligibility),
    minItemValue: normalizeNonNegativeValue(rule.minItemValue),
    maxItemValue: normalizeOptionalNonNegativeValue(rule.maxItemValue),
    options: (Array.isArray(rule.options) ? rule.options : []).map(
      (option) => ({
        ...option,
        value: normalizeIncentiveValue(option.value, option.valueType),
      }),
    ),
  }));

export const normalizeOptimizationRules = (rules: RefundOptimizationRule[]) =>
  rules.map((rule) => ({
    ...rule,
    minItemValue: normalizeNonNegativeValue(rule.minItemValue),
    maxItemValue: normalizeOptionalNonNegativeValue(rule.maxItemValue),
    bonusValue: normalizePercentageValue(rule.bonusValue),
  }));
